module.exports = __webpack_public_path__ + "img/17_104.5ba504df.png";